import React from "react";
import { useLang } from "../../context/LanguageContext";

const About = () => {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="py-24 sm:py-32 bg-[#0A0A0C] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-5 relative">
          <div className="aspect-[3/4] overflow-hidden relative">
            <img
              src="https://images.pexels.com/photos/265947/pexels-photo-265947.jpeg"
              alt="about"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C]/40 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block">
            <div className="bg-[#D4AF37] text-[#0A0A0C] px-8 py-6">
              <div className="font-display text-4xl">10+</div>
              <div className="text-[10px] tracking-[0.3em] uppercase">Années · Yıl</div>
            </div>
          </div>
        </div>
        <div className="md:col-span-6 md:col-start-7">
          <div className="text-xs tracking-[0.4em] uppercase text-[#D4AF37] mb-6">
            {t("about.overline")}
          </div>
          <h2 className="font-display font-light text-4xl sm:text-5xl tracking-tighter text-white leading-[1]">
            {t("about.title")}
          </h2>
          <p className="mt-8 text-base md:text-lg text-white/70 leading-relaxed">
            {t("about.body_1")}
          </p>
          <p className="mt-4 text-base text-white/60 leading-relaxed">
            {t("about.body_2")}
          </p>
          <div className="mt-10 grid grid-cols-3 gap-6">
            <div className="border-t border-[#D4AF37]/30 pt-4">
              <div className="font-display text-3xl text-white">500+</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mt-1">Events</div>
            </div>
            <div className="border-t border-[#D4AF37]/30 pt-4">
              <div className="font-display text-3xl text-white">5</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mt-1">Services</div>
            </div>
            <div className="border-t border-[#D4AF37]/30 pt-4">
              <div className="font-display text-3xl text-white">100%</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mt-1">Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
